type Props = {
  children: React.ReactNode;
};

const style = {
  height: "45px",
  width: "100%",
};

const PageLayout = (props: Props): JSX.Element => {
  const url: string = window.location.pathname;
  return (
    <>
      {url === "/" ? <></> : <div style={style}></div>}
      {props.children}
    </>
  );
};

export default PageLayout;
